module.exports = "pegasus/assets/blocks/header-8-theme3.png";